module.exports = __webpack_public_path__ + "static/media/add_product.f0cc7b6d.png";